import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0036',
    ecrans: ['00-2'],
    params: ['id', '?el1cleint', '?prucleint', '?pecann']
});
